/* ============================================================
   Craft Com : offres Sites internet (oct. 2026)
   Remplace l'ancien « Site Shopify 300 € » par les 3 formules
   dans la grille Services et le récap du devis, et ajoute un
   aperçu visuel (vraie réalisation) sur les cartes concernées.
   Se charge APRÈS app.js (réutilise SERVICES, state, buildServices).
   ============================================================ */
(function () {
  if (typeof SERVICES === 'undefined' || typeof state === 'undefined') return;
  var NEW = [
    { id: 'siteessentiel', name: 'Site Essentiel',         price: 490,  unit: null, desc: '1 page, version mobile, bouton appel et WhatsApp' },
    { id: 'sitepro',       name: 'Site vitrine Pro',       price: 1200, unit: null, desc: '4 à 6 pages, devis en ligne, fiche Google' },
    { id: 'sitemachine',   name: 'Site Machine à clients', price: 1900, unit: null, desc: 'Dès 1 900 €, pages par ville et suivi des appels' },
    { id: 'shopify',       name: 'Boutique Shopify',       price: null, unit: null, desc: 'E-commerce sur mesure', quote: true }
  ];
  var i = -1;
  SERVICES.forEach(function (s, k) { if (s.id === 'shopify') i = k; });
  if (i !== -1) {
    SERVICES.splice.apply(SERVICES, [i, 1].concat(NEW));
  } else {
    var j = -1;
    SERVICES.forEach(function (s, k) { if (s.id === 'autres') j = k; });
    SERVICES.splice.apply(SERVICES, [j === -1 ? SERVICES.length : j, 0].concat(NEW));
  }
  var saved = {};
  try { saved = JSON.parse(localStorage.getItem('craftcom_sel')) || {}; } catch (e) {}
  NEW.forEach(function (n) { state[n.id] = saved[n.id] || { sel: false, qty: 1 }; });
  if (saved.shopify && !saved.siteessentiel && !saved.sitepro && !saved.sitemachine) state.shopify = saved.shopify;

  var grid = document.getElementById('svcGrid');
  if (grid && typeof buildServices === 'function') {
    grid.innerHTML = '';
    buildServices();
    if (typeof observeReveals === 'function') observeReveals();
  }

  /* aperçu : une vraie réalisation en haut des cartes qui en ont une */
  if (grid) {
    var T = window.CC_THUMBS || {};
    [].forEach.call(grid.querySelectorAll('.svc'), function (el) {
      var src = T[el.dataset.id];
      if (!src || el.querySelector('.svc-thumb')) return;
      var f = document.createElement('div');
      f.className = 'svc-thumb';
      f.innerHTML = '<img loading="lazy" alt="" src="' + src + '">';
      el.insertBefore(f, el.firstChild);
      el.classList.add('has-thumb');
    });
  }
  if (typeof renderFloat === 'function') renderFloat();
})();
